import * as apiService from "./v2/apiService";
import * as endPoints from "../constants/v2/endPoints";

const withId = (url, key, id) => url.replace(`:${key}`, encodeURIComponent(id));

const unwrap = async (request) => {
  let response;
  try {
    response = await request;
  } catch (error) {
    const message =
      error?.response?.data?.message || "Something went wrong. Try again.";
    const wrapped = new Error(message);
    wrapped.code = error?.response?.data?.errorCode;
    wrapped.data = error?.response?.data?.data;
    throw wrapped;
  }
  if (!response || response.errorCode !== 0) {
    const wrapped = new Error(
      response?.message || "Something went wrong. Try again.",
    );
    wrapped.code = response?.errorCode;
    wrapped.data = response?.data;
    throw wrapped;
  }
  return response.result;
};

export const getCloseOutContext = (wantAdId) =>
  unwrap(
    apiService.apiCall(
      withId(endPoints.WANTAD_CLOSE_OUT, "wantAdId", wantAdId),
      "GET",
    ),
  );

export const submitCloseOut = (wantAdId, { reason, introductionId, details }) =>
  unwrap(
    apiService.apiCall(
      withId(endPoints.WANTAD_CLOSE_OUT, "wantAdId", wantAdId),
      "POST",
      {
        reason,
        introductionId: introductionId || undefined,
        details: details || {},
      },
    ),
  );

export const getCheckIns = () =>
  unwrap(apiService.apiCall(endPoints.WANTAD_CHECK_INS, "GET"));

export const confirmStillLooking = (wantAdId) =>
  unwrap(
    apiService.apiCall(
      withId(endPoints.WANTAD_CONFIRM, "wantAdId", wantAdId),
      "POST",
      {},
    ),
  );

export const getNextBuyerDraft = (wantAdId) =>
  unwrap(
    apiService.apiCall(
      withId(endPoints.WANTAD_NEXT_BUYER_DRAFT, "wantAdId", wantAdId),
      "GET",
    ),
  );

export const getSentIntroductions = (params = {}) =>
  unwrap(apiService.apiCall(endPoints.INTRODUCTIONS_SENT, "GET", params));

export const getSentSummary = ({
  inventoryIds = [],
  mlsListingKeys = [],
} = {}) =>
  unwrap(
    apiService.apiCall(endPoints.INTRODUCTIONS_SENT_SUMMARY, "GET", {
      inventoryIds: inventoryIds.join(","),
      mlsListingKeys: mlsListingKeys.join(","),
    }),
  );
